// extracted by mini-css-extract-plugin
module.exports = {"divContent":"ProviderPickStockTotals_divContent__1zd-q","labelTitle":"ProviderPickStockTotals_labelTitle__11a0L"};